import type { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { Flex } from "@unifize/sarah";

import type { FormsById } from "src/types";
import ImageLabel from "src/containers/user/ImageLabel/Medium";
import { Nullable } from "src/ts-types";

interface CellRendererParams extends CustomCellRendererProps {
  data: { id: number };
  formsById: FormsById;
}

export const CreatedByCellRenderer = ({
  data,
  formsById,
}: CellRendererParams): Nullable<React.ReactElement> => {
  const form = formsById[data.id];

  if (!form) return null;

  return (
    <Flex items="center" height="100%">
      <ImageLabel uid={form.creator} />
    </Flex>
  );
};
